export class IngUpload<T>{
  value: T;
  key: string;
  label: string;
  description: string;
  required: boolean;
  groupId: any;
  order: number;
  readonly: boolean;
  controlType: string;
  placeHolder: string;
  classContainer: string;
  constructor(
    options: {
      value?: T,
      key?: string,
      label?: string,
      description?: string,
      required?: boolean,
      readonly?: boolean,
      order?: number,
      controlType?: string,
      placeHolder?: string,
      classContainer?: string
    } = {}
  ) {
    this.key            = options.key || '';
    this.value          = options.value;
    this.description    = options.description || '';
    this.label          = options.label || '';
    this.readonly       = options.readonly || false;
    this.order          = options.order === undefined ? 1 : options.order;
    this.required       = !!options.required;
    this.controlType    = options.controlType || 'text';
    this.placeHolder    = options.placeHolder || '';
    this.classContainer = options.classContainer || 'col-md-12';
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/ing-dynamic-form/inputs/ing-upload.ts